import type { EmailFilterDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';
import type { HasEmailFilterValue } from '../../../components/IncomingFeedback/ResponsesFilters/HasEmailFilter/HasEmailType';
import {
  HAS_EMAIL_TYPE,
  isAllResponsesEmailFilterValue,
} from '../../../components/IncomingFeedback/ResponsesFilters/HasEmailFilter/HasEmailType';

export function hasEmailFilterConverter(
  filterValue: HasEmailFilterValue,
): EmailFilterDto | undefined {
  if (isAllResponsesEmailFilterValue(filterValue)) {
    return undefined;
  }

  return {
    type: IncomingFeedbackDtoFilters.EMAIL,
    value: filterValue === HAS_EMAIL_TYPE.YES,
  };
}
